import breakpoints from "shared/theme/size/breakpoint";

const size = {
  breakpoints,
};

export default size;
